import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import {
  responseFacebook,
  responseGoogle
} from '../../actions/account/connectService';
import { register, reset } from '../../actions/account/register';
import { APP_SITE_ID } from '../../config/entrypoint';
import { FB_ID } from '../../config/facebook';
import { GOOGLE_ID } from '../../config/google';
import { STRIPE_SUBSCRIPTION_PRICE } from '../../config/stripe';
import { isLoggedIn } from '../../utils/auth';
import { VersionLink as Link } from '../VersionLink';
import RegistrationForm from './RegistrationForm';

class Register extends Component {
  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    registered: PropTypes.object,
    register: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
  };

  componentWillUnmount() {
    this.props.reset();
  }

  render() {
    if (this.props.registered || isLoggedIn()) {
      // if (this.props.registered) {
      //   return <Redirect to="/first-experience" />;
      // }
      // return <Redirect to="/procedures/" />;
      return <Redirect to="/dashboard" />;
    }

    return (
      <Row>
        <Col
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
          lg={{
            span: 4,
            offset: !!APP_SITE_ID && 'immigration' === APP_SITE_ID ? 2 : 4
          }}
        >
          <Card className={'mt-5'}>
            <Card.Body>
              <Card.Title>
                <h5>Create a Lista Account</h5>
              </Card.Title>
              <Card.Subtitle className={'mb-4'}>
                <Link to="/login" className={'small card-link'}>
                  or sign in to your account
                </Link>
              </Card.Subtitle>

              {this.props.loading && (
                <div className="alert alert-info" role="status">
                  Loading...
                </div>
              )}
              {this.props.error && (
                <div className="alert alert-danger" role="alert">
                  <span
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.props.error}
                </div>
              )}

              <RegistrationForm
                onSubmit={this.props.register}
                values={this.props.item}
              />

              {!!FB_ID && (
                <FacebookLogin
                  appId={FB_ID}
                  autoLoad={false}
                  fields="id,first_name,last_name,name,email,picture.type(large)"
                  callback={this.props.responseFacebook}
                  size="small"
                  icon="fa-facebook-square"
                  buttonStyle={{ textTransform: 'inherit', width: '100%' }}
                />
              )}

              {!!GOOGLE_ID && (
                <GoogleLogin
                  clientId={GOOGLE_ID}
                  buttonText="Login with Google"
                  onSuccess={this.props.responseGoogle}
                  onFailure={this.props.responseGoogle}
                  className={'btn-block mt-3'}
                />
              )}
            </Card.Body>
            {/*
            <Card.Footer className={'text-center'}>
              <Link to="/terms" className={'small card-link'}>
                Terms of Service
              </Link>
              <Link to="/privacy" className={'small card-link'}>
                Privacy Policy
              </Link>
            </Card.Footer>
            */}
          </Card>
        </Col>
        {!!APP_SITE_ID &&
          'immigration' === APP_SITE_ID &&
          !!STRIPE_SUBSCRIPTION_PRICE && (
            <Col
              sm={{ span: 8, offset: 2 }}
              md={{ span: 6, offset: 3 }}
              lg={{ span: 6, offset: 0 }}
            >
              <div className={'pricingContainer my-5'}>
                <p className="pricing">
                  <span>${STRIPE_SUBSCRIPTION_PRICE}</span> per month per user
                </p>
                <p className="pricing">
                  {/*Reusable case process templates available for purchase after*/}
                  Reusable case workflows available for purchase after sign up
                </p>
              </div>
            </Col>
          )}
      </Row>
    );
  }
}

const mapStateToProps = state => {
  const { registered, error, loading } = state.account.register;
  return { registered, error, loading };
};

const mapDispatchToProps = dispatch => ({
  responseFacebook: response => dispatch(responseFacebook(response)),
  responseGoogle: response => dispatch(responseGoogle(response)),
  register: values => dispatch(register(values)),
  reset: () => dispatch(reset())
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
